//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {};
  },
  created() {},

  methods: {
    onTheADownClick() {
      if (this.controlItem.ControlValue == "") {
        this.$msg.alert("当前无附件");
        return;
      }
      //附件下载
      window.open(this.controlItem.ControlValue, "_blank");
    }
  }
};
